/**
 * Analytics configuration for the web app.
 *
 * Uses PostHog for product analytics, feature flags, and user tracking.
 * Configure via VITE_POSTHOG_KEY environment variable.
 */

import type { AnalyticsConfig } from "@jumpbean/analytics";

const posthogKey = import.meta.env.VITE_POSTHOG_KEY;
const isDevelopment = import.meta.env.DEV;

if (!posthogKey && !isDevelopment) {
  console.warn(
    "[Analytics] VITE_POSTHOG_KEY not set. Analytics will be disabled."
  );
}

/**
 * Analytics configuration for PostHog.
 *
 * In development:
 * - Analytics is disabled by default (no API key required)
 * - Set VITE_POSTHOG_KEY to enable during development
 * - Debug mode is enabled when analytics is active
 *
 * In production:
 * - Requires VITE_POSTHOG_KEY to be set
 * - Debug mode is disabled
 */
export const analyticsConfig: AnalyticsConfig = {
  apiKey: posthogKey || "disabled",
  apiHost: import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com",
  disabled: !posthogKey,
  debug: isDevelopment && !!posthogKey,
  capturePageview: true,
  capturePageleave: true,
};
